<template>
  <div id="ModifyUserPass">
    <el-dialog :center="true" title="密码修改" :visible.sync="dialogVisible" width="500px">
      <el-form :model="updatePassForm" :rules="rules" ref="updatePassForm" label-width="100px" class="demo-ruleForm" @close="resetForm('updatePassForm')">
        <el-form-item label="手机号号码">
          <el-col :span="4">&nbsp;</el-col>
          <el-col :span="10">
            {{userPhone}}
          </el-col>
          <el-col :span="10">
            <div class="orange-btn">
              <ebSendCode :butId="butId" :params="params" />
            </div>
          </el-col>
        </el-form-item>
        <el-form-item label="输入验证码" prop="verificationCode">
          <el-input class="eb-input" v-model="updatePassForm.verificationCode" placeholder="输入验证码"></el-input>
        </el-form-item>
        <el-form-item label="输入新密码" prop="newPassword">
          <el-input class="eb-input" type="password" v-model="updatePassForm.newPassword" placeholder="输入新密码"></el-input>
        </el-form-item>
        <el-form-item label="验证新密码" prop="confirmPassword">
          <el-input class="eb-input" type="password" v-model="updatePassForm.confirmPassword" placeholder="验证新密码"></el-input>
        </el-form-item>
        <div class="eb-button-group">
          <el-button class="eb-button-group-btn eb-button-orange eb-button-big" @click="resetForm('updatePassForm')">关闭</el-button>
          <el-button class="eb-button-group-btn eb-button-orange eb-button-big" @click="editUserPassBtn('updatePassForm')">确定</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import eventBus from '@/plugins/event-bus';
import { editUserPwd } from '@/services/user/user-service';
import ebSendCode from '@/components/common/eb-send-code';
export default {
  name: 'ModifyUserPass',
  components: {
    ebSendCode
  },
  data() {
    let validateCode = (rule, value, callback) => {
      let reg = /^\d{6}$/;
      if (!value) {
        callback(new Error('请输入手机验证码'));
      } else if (!reg.test(value)) {
        callback(new Error('请输入6位数字手机验证码'));
      } else {
        callback();
      }
    };
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'));
      } else {
        if (this.updatePassForm.confirmPassword !== '') {
          this.$refs.updatePassForm.validateField('confirmPassword');
        }
        callback();
      }
    };
    let validateConfirmPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.updatePassForm.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      dialogVisible: false,
      butId: 'modifyPass',
      params: {
        phoneNumber: '',
        verificationCodeType: 'verification_code'
      },
      userPhone: '',
      updatePassForm: {
        verificationCode: '',
        newPassword: '',
        confirmPassword: ''
      },
      rules: {
        verificationCode: [{ required: true, validator: validateCode, trigger: 'blur' }],
        newPassword: [
          { required: true, validator: validatePass, trigger: 'blur' },
          { min: 8, max: 16, message: '长度在8 到 16 个字符', trigger: 'blur' }
        ],
        confirmPassword: [{ required: true, validator: validateConfirmPass, trigger: 'blur' }]
      }
    };
  },
  created() {
    eventBus.$on('modifyUserPass', userPhone => {
      this.dialogVisible = true;
      this.userPhone = userPhone;
      this.params.phoneNumber = userPhone;
    });
  },
  methods: {
    editUserPassBtn(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.editUserPass();
        } else {
          return false;
        }
      });
    },
    async editUserPass() {
      var params = {
        verificationCode: this.updatePassForm.verificationCode,
        userPhone: this.userPhone,
        newPassword: this.updatePassForm.newPassword
      };
      try {
        let { data } = await editUserPwd(params);
        if (data.returnCode === '01') {
          this.$message.success('密码修改成功！');
          this.dialogVisible = false;
        } else if (data.returnCode === '05') {
          this.$message.error('手机验证码错误！');
        } else {
          this.$message.error('密码修改失败！');
        }
      } catch (error) {
        this.$message.error('请检查服务器连接!');
      }
    },
    resetForm: function(formName) {
      this.dialogVisible = false;
      this.$refs[formName].resetFields();
    }
  },
  beforeDestroy() {
    eventBus.$off('modifyUserPass');
  }
};
</script>
<style scoped lang="less">
#ModifyUserPass {
  .orange-btn {
    height: 30px;
    width: 120px;
    display: table-cell;
    text-align: center;
    vertical-align: middle;
    float: right;
  }
}
</style>
